import { render, staticRenderFns } from "./CompanyManagement.vue?vue&type=template&id=3158ddff"
import script from "./CompanyManagement.vue?vue&type=script&lang=js"
export * from "./CompanyManagement.vue?vue&type=script&lang=js"
import style0 from "./CompanyManagement.vue?vue&type=style&index=0&id=3158ddff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports